import { createModel } from "@rematch/core";
import * as _ from "lodash";
import moment from "moment";
import { DashboardFilterState, LineChartsData } from "src/types";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, multiRequest, signoutIfUnauthorized } from "./utilities";

const initialState: LineChartsData = {
  loading: false,
  timestampData: [],
  pending: null,
};

export const lineChartsData = createModel<RootModel>()({
  state: initialState,
  reducers: {
    fetchPending(state, requestId: string) {
      return multiRequest.updatePending(state, requestId);
    },
    fetchSuccess(
      state,
      payload: LineChartsData["timestampData"],
      requestId: string
    ) {
      return multiRequest.updateSuccess(
        { timestampData: payload },
        state,
        requestId
      );
    },
    fetchFail(state, requestId: string) {
      return multiRequest.updateFail(state, requestId);
    },
  },
  effects: (dispatch) => ({
    async fetchLineChartsData(
      dashboardFilter: DashboardFilterState,
      rootState
    ) {
      const requestId = multiRequest.getRequestId();
      dispatch.lineChartsData.fetchPending(requestId);

      const token = checkToken(rootState, () =>
        dispatch.lineChartsData.fetchFail(requestId)
      );
      if (!token) return;

      const handleTimestampData = (
        data: Array<{ date: string; avg: string; sum: string }>
      ) => {
        const formatDate = (date: string) => moment(date).format("DD.MM.YY");
        return data.map((item) => {
          return {
            date: formatDate(item.date),
            avg: _.toNumber(item.avg),
            sum: _.toNumber(item.sum),
          };
        });
      };

      try {
        const lineChartsDataResult = await api.fetchLineChartsData(
          token,
          dashboardFilter
        );
        const lineChartsData = handleTimestampData(lineChartsDataResult.data);
        dispatch.lineChartsData.fetchSuccess(lineChartsData, requestId);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.lineChartsData.fetchFail(requestId);
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/lineChartsData.ts